import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  getCategoriesTags,
  getLoadingCategoriesTags,
} from 'Store/Selectors/marketplace'

import MatchCategories from './MatchCategories'

const selector = createStructuredSelector({
  categoriesTags: getCategoriesTags,
  isLoadingCategoriesTags: getLoadingCategoriesTags,
})

const actions = {}

export default connect(selector, actions)(MatchCategories)
